import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface DownloadSavedSnackbarData {
  message: string;
  primaryLabel: string;
  primaryAction: () => void;
  secondaryLabel: string;
  secondaryAction: () => void;
}

// Custom snackbar body for "file saved" notifications. MatSnackBar's default
// template only supports a single action button — this component lets us
// surface two (Open + Share) without changing the snackbar's outer chrome.
@Component({
  selector: 'app-download-saved-snackbar',
  templateUrl: './download-saved-snackbar.component.html',
  styleUrls: ['./download-saved-snackbar.component.scss'],
})
export class DownloadSavedSnackbarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<DownloadSavedSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: DownloadSavedSnackbarData
  ) {}

  onPrimary(): void {
    this.data.primaryAction();
    this.snackBarRef.dismiss();
  }

  onSecondary(): void {
    this.data.secondaryAction();
    this.snackBarRef.dismiss();
  }

  onDismiss(): void {
    this.snackBarRef.dismiss();
  }
}
